import { jsxs as b, jsx as t, Fragment as Ie } from "react/jsx-runtime";
import { useState as Z, useEffect as Be, useMemo as J, useCallback as Ve } from "react";
import { useI18n as $ } from "next-localization";
import { r as _e } from "../../chunks/sessions-api.CDuxaXsQ.js";
import { q as ue } from "../../chunks/stale.constant.De1PuSBj.js";
import { u as Ye } from "../../chunks/use-is-auth-token-generated.BkMrw8To.js";
import { NeuFeedback as Ke, NeuModal as U, NeuRadio as me, NeuCard as je, NeuSnackbar as Qe } from "@hcahealthcaredpx/neutron-react";
import { u as ee, a as ke, b as De, c as Ge, d as We } from "../../chunks/use-accounts-relationships.L7d75NNZ.js";
import { u as w } from "../../chunks/useModal.DSDGkQa1.js";
import { o as Ce, s as S, a as ye, M as ze, u as Xe } from "../../chunks/types.BJMlOVBS.js";
import { L as Je } from "../../chunks/loading-overlay.tDsRLOTG.js";
import { i as Ze, P as fe } from "../../chunks/page-content.B0ugSU6N.js";
import { a as et, M as I } from "../../chunks/modifiable-list.C-OdvAIi.js";
import { Text as tt, withDatasourceCheck as nt, RichText as ve } from "@sitecore-jss/sitecore-jss-nextjs";
import { useQueryClient as He } from "@tanstack/react-query";
import { u as _ } from "../../chunks/use-connected-relationship-info.DvMNYpDA.js";
import { c as qe } from "../../chunks/clsx.OuTLNxxd.js";
import { u as Pe } from "../../chunks/use-accounts-relation-types.BZfXDW3J.js";
import { useForm as Me } from "react-hook-form";
import { f as be } from "../../chunks/format-date.Dafoc_k1.js";
import { F as ot } from "../../chunks/form-date-picker.LFmaEfS6.js";
import { F as v, a as xe, b as B } from "../../chunks/form-wrapper.CxSd-0ur.js";
import { R as he, F as at } from "../../chunks/form-mask-input.92EW49hv.js";
import { getFormattedDate as rt } from "../../utils/date-time/index.js";
import { u as Ue } from "../../chunks/useNetworkStatus.B65eRjoK.js";
import { M as it } from "../../chunks/mho-action-buttons.fY1B40h9.js";
import { c as $e } from "../../chunks/use-account.DkVfV1FC.js";
import { i as st } from "../../chunks/utils.CWNG23OC.js";
import { u as lt } from "../../chunks/use-update-relationship.BhM7x_In.js";
const ct = (o) => {
  const [n, a] = Z(18);
  return Be(() => {
    if (!o) {
      a(18);
      return;
    }
    a((() => {
      const [u, c, l] = o.split("/").map(Number), h = new Date(l, c - 1, u), r = /* @__PURE__ */ new Date();
      let d = r.getFullYear() - h.getFullYear();
      return r.getMonth() > h.getMonth() || r.getMonth() === h.getMonth() && r.getDate() >= h.getDate() || (d -= 1), d;
    })());
  }, [o]), n;
}, dt = [
  { value: "CELL", label: "Cell" },
  { value: "HOME", label: "Home" },
  { value: "WORK", label: "Work" }
], mt = (o, n, a) => Ce({
  firstName: S().min(1, { message: o("Mho.PageContent.Profile.EmergencyContact.Validation.FirstName") }).regex(he.name, {
    message: o("Mho.PageContent.Profile.EmergencyContact.Validation.ValidFirstName")
  }),
  lastName: S().min(1, { message: o("Mho.PageContent.Profile.EmergencyContact.Validation.LastName") }).regex(he.name, {
    message: o("Mho.PageContent.Profile.EmergencyContact.Validation.ValidLastName")
  }),
  relationshipType: S().min(1, {
    message: o("Mho.PageContent.Profile.EmergencyContact.Validation.ValidRelationshipPatient")
  }),
  // TODO: need error messages update for min date, max date, future data, invalid date, etc.
  dateOfBirth: S().min(1, {
    message: o("Mho.PageContent.RecordsLinking.Form.Validations.ValidDate")
  }).refine((g) => g >= n && g <= a, {
    message: o("Mho.PageContent.RecordsLinking.Form.Validations.ValidDate")
  }),
  phone: S().regex(he.phone, {
    message: o("Mho.PageContent.Profile.EmergencyContact.Validation.ValidPhoneNumber")
  }),
  phoneType: S().min(1, {
    message: o("Mho.PageContent.Profile.EmergencyContact.Validation.ValidPhoneType")
  })
}), ht = Ce({
  relationship: S()
}), pt = (o, n) => Ce({
  relationshipId: n ? S().optional() : S().min(1, {
    message: o("Mho.PageContent.Profile.EmergencyContact.Labels.ValidContactName")
  }),
  relationshipType: S().min(1, {
    message: o("Mho.PageContent.Profile.EmergencyContact.Validation.ValidRelationshipPatient")
  })
}), ut = () => {
  const o = /* @__PURE__ */ new Date(), n = new Date(o.getFullYear() - 13, o.getMonth(), o.getDate());
  return { min: "1900-01-01", max: rt(n.toISOString(), "yyyy-MM-dd") ?? "" };
}, ge = (o) => typeof o > "u" ? "" : o == null ? void 0 : o.toLowerCase().replace(/_/g, " ").replace(/\b\w/g, (n) => n.toUpperCase()), gt = ({ addContact: o, handleClose: n }) => {
  const { t: a } = $(), { connectedRelUsername: g } = _(), { data: u } = Pe(), { min: c, max: l } = J(() => ut(), []), h = Ve(() => mt(a, c, l), [l, c, a]), r = Me({
    defaultValues: {
      firstName: "",
      lastName: "",
      relationshipType: "",
      dateOfBirth: "",
      phone: "",
      phoneType: ""
    },
    resolver: ye(h())
  }), d = () => {
    r.reset(), n();
  };
  return /* @__PURE__ */ b(
    v,
    {
      onCancel: d,
      onSubmit: (e) => {
        o({
          relationship: {
            ...e,
            dateOfBirth: be(new Date(e.dateOfBirth)),
            createdTs: /* @__PURE__ */ new Date(),
            relationType: e.relationshipType
          },
          flag: !0,
          connectedRelUsername: g
        }), d();
      },
      methods: r,
      padding: "px-0",
      rowGap: 4,
      cancelButtonText: a("Mho.PageContent.Profile.EmergencyContact.Label.Cancel"),
      submitButtonText: a("Mho.PageContent.Profile.EmergencyContact.Label.Save"),
      buttonsAlignment: "end",
      children: [
        /* @__PURE__ */ b(v.Row, { children: [
          /* @__PURE__ */ t(
            xe,
            {
              name: "firstName",
              label: a("Mho.PageContent.Profile.EmergencyContact.Label.FirstName"),
              maxLength: 100,
              triggerValidationOnChange: !0,
              required: !0
            }
          ),
          /* @__PURE__ */ t(
            xe,
            {
              name: "lastName",
              label: a("Mho.PageContent.Profile.EmergencyContact.Label.LastName"),
              maxLength: 100,
              triggerValidationOnChange: !0,
              required: !0
            }
          )
        ] }),
        /* @__PURE__ */ t(v.Row, { children: /* @__PURE__ */ t(
          B,
          {
            name: "relationshipType",
            label: a("Mho.PageContent.Profile.EmergencyContact.Label.RelationshipPatient"),
            items: u || [],
            triggerValidationOnChange: !0,
            required: !0
          }
        ) }),
        /* @__PURE__ */ t(v.Row, { children: /* @__PURE__ */ t(
          ot,
          {
            name: "dateOfBirth",
            label: a("Mho.PageContent.Profile.EmergencyContact.Label.DateOfBirth"),
            min: c,
            max: l,
            triggerValidationOnChange: !0,
            required: !0
          }
        ) }),
        /* @__PURE__ */ b(v.Row, { children: [
          /* @__PURE__ */ t(
            at,
            {
              format: "phone",
              name: "phone",
              label: a("Mho.PageContent.Profile.EmergencyContact.Label.PrimaryPhone"),
              maxLength: 13,
              triggerValidationOnChange: !0,
              required: !0
            }
          ),
          /* @__PURE__ */ t(
            B,
            {
              name: "phoneType",
              label: a("Mho.PageContent.Profile.EmergencyContact.Label.PhoneType"),
              items: dt,
              triggerValidationOnChange: !0,
              disabled: r.getValues("phone").length === 0,
              required: !0
            }
          )
        ] })
      ]
    }
  );
}, Ct = (o, n) => J(() => o != null && o.length ? o.map(n) : [], [o, n]), yt = ({
  changeContact: o,
  handleClose: n,
  preSelectedRelationship: a,
  addButtonText: g,
  addButtonFunc: u
}) => {
  const { t: c } = $(), { data: l = [], isFetching: h } = ee(), { connectedRelUsername: r } = _(), d = Me({
    defaultValues: {
      relationship: ""
    },
    resolver: ye(ht)
  });
  Be(() => {
    a && d.setValue("relationship", a.toString());
  }, [a, d]);
  const e = !d.watch("relationship") || !(l != null && l.length), y = Ct(
    l,
    (P) => {
      var s;
      const m = ge(P.relationType), i = m ? `- ${m}` : "";
      return {
        value: (s = P.myHealthOneId) == null ? void 0 : s.toString(),
        label: `${P.firstName} ${P.lastName} ${i}`
      };
    }
  ), f = (P) => {
    const m = l == null ? void 0 : l.find(
      (i) => {
        var s;
        return ((s = i.myHealthOneId) == null ? void 0 : s.toString()) === P.relationship;
      }
    );
    m && (o({
      relationship: {
        ...m,
        dateOfBirth: m.dateOfBirth ? be(new Date(m.dateOfBirth)) : void 0
      },
      flag: !0,
      connectedRelUsername: r
    }), n());
  };
  return h ? /* @__PURE__ */ t(Ke, { kind: "spinner", className: "px-6 py-4" }) : /* @__PURE__ */ b(
    v,
    {
      onSubmit: f,
      onCancel: n,
      methods: d,
      padding: "px-0",
      rowGap: 4,
      cancelButtonText: c("Mho.PageContent.Profile.EmergencyContact.Label.Cancel"),
      submitButtonText: c("Mho.PageContent.Profile.EmergencyContact.Label.Save"),
      isSubmitDisabled: e,
      buttonsAlignment: "end",
      children: [
        !Ze(l) && /* @__PURE__ */ t(v.Row, { children: /* @__PURE__ */ t(
          B,
          {
            name: "relationship",
            label: "Relationship",
            items: y,
            required: !0
          }
        ) }),
        l.length < ze && /* @__PURE__ */ t("div", { className: "d-flex", children: /* @__PURE__ */ t(et, { text: g, onClick: u }) })
      ]
    }
  );
}, Ae = ({
  isOpen: o,
  heading: n,
  buttonTitle: a,
  closeModal: g,
  onCreate: u,
  onEdit: c,
  preSelectedRelationship: l
}) => {
  const [h, r] = Z(!1), { error: d } = ee(), { error: E } = Pe(), e = (d == null ? void 0 : d.message) || (E == null ? void 0 : E.message), y = () => {
    g(), r(!1);
  };
  return /* @__PURE__ */ b(
    U,
    {
      label: n,
      active: o,
      backdropDismiss: !1,
      size: "large",
      onNeuDismiss: y,
      children: [
        /* @__PURE__ */ t(fe, { className: "px-2", errorMessage: e }),
        /* @__PURE__ */ t("div", { className: qe("pt-1", "p-3", h ? "overflow-auto" : "overflow-visible"), children: h ? /* @__PURE__ */ t(gt, { addContact: u, handleClose: y }) : /* @__PURE__ */ t(
          yt,
          {
            changeContact: c,
            handleClose: y,
            preSelectedRelationship: l,
            addButtonText: a,
            addButtonFunc: () => {
              r(!0);
            }
          }
        ) })
      ]
    }
  );
}, Fe = ({
  heading: o,
  description: n,
  deleteContact: a,
  contactId: g,
  isOpen: u,
  closeModal: c,
  isGuardian: l = !1
}) => {
  const { t: h } = $(), { data: r } = ee(), { isOnline: d } = Ue(), { connectedRelUsername: E, queryParams: e, isConnectedRelationship: y } = _({
    levelOfDetail: "FULL"
  }), { data: f } = $e({
    queryParams: e
  }), P = () => {
    var x, N;
    const m = r == null ? void 0 : r.find(
      (R) => {
        var M;
        return ((M = R.myHealthOneId) == null ? void 0 : M.toString()) === g.toString();
      }
    ), i = l ? (x = f == null ? void 0 : f.user) == null ? void 0 : x.guardianUserRelationship : (N = f == null ? void 0 : f.user) == null ? void 0 : N.emergencyContactUserRelationship, s = y && (i == null ? void 0 : i.myHealthOneId) === g ? i : null;
    !m && !s || !d || (a({
      relationship: m ? {
        ...m,
        dateOfBirth: m.dateOfBirth ? be(new Date(m.dateOfBirth)) : void 0
      } : s,
      connectedRelUsername: E,
      flag: !1
    }), c());
  };
  return /* @__PURE__ */ b(
    U,
    {
      label: o,
      active: u,
      backdropDismiss: !0,
      size: "large",
      onNeuDismiss: c,
      children: [
        /* @__PURE__ */ t(U.Content, { children: /* @__PURE__ */ t(tt, { tag: "p", field: { value: n } }) }),
        /* @__PURE__ */ t(U.Footer, { children: /* @__PURE__ */ t(
          it,
          {
            buttonsAlignment: "end",
            primaryText: h("Mho.PageContent.Profile.EmergencyContact.Labels.Yes") || "Yes",
            onPrimaryClick: P,
            secondaryText: h("Mho.PageContent.Profile.EmergencyContact.Label.Cancel"),
            onSecondaryClick: c
          }
        ) })
      ]
    }
  );
}, pe = {
  relationshipId: "relationshipId",
  relationshipType: "relationshipType"
}, we = ({
  heading: o,
  active: n,
  onClose: a,
  modalContentError: g,
  userFirstName: u,
  userLastName: c,
  relatedMhoId: l,
  isGuardian: h = !1
}) => {
  var G, z, X, H;
  const { t: r } = $(), d = He(), { isOnline: E } = Ue(), e = JSON.parse(((G = window == null ? void 0 : window.localStorage) == null ? void 0 : G.getItem("mainUser")) || "{}"), y = e == null ? void 0 : e.dependentRelationships, f = ((z = e == null ? void 0 : e.user) == null ? void 0 : z.firstName) || "", P = ((X = e == null ? void 0 : e.user) == null ? void 0 : X.lastName) || "", m = (H = e == null ? void 0 : e.contacts) == null ? void 0 : H.find((p) => st(p.contactType)), i = (m == null ? void 0 : m.contactInfo) || "", s = (m == null ? void 0 : m.contactType) || "", { connectedRelId: x, mainUserMhoId: N, connectedRelUsername: R } = _(), [M, Y] = Z(!0), te = Ve(
    () => pt(r, M),
    [r, M]
  ), K = Me({
    mode: "all",
    defaultValues: {
      relationshipId: "",
      relationshipType: ""
    },
    resolver: ye(te())
  }), { reset: j, watch: ne } = K, [V, T] = ne(["relationshipId", "relationshipType"]), oe = J(() => M ? !T : !V || !T, [M, V, T]), k = () => {
    Y(!0), j(), a();
  }, ae = r(
    "Mho.PageContent.Profile.EmergencyContact.Label.EmergencyContactName"
  ).replace("{name}", `${f} ${P}`), { data: D } = Pe(), { mutate: Q, isPending: re } = ke(
    {
      onSuccess: () => {
        d.invalidateQueries({ queryKey: ue.user("FULL") }), k();
      },
      onError: (p) => {
        console.error("Error adding emergency contact:", p);
      }
    }
  ), { mutate: ie } = lt({
    onSuccess: () => Q({
      flag: !0,
      connectedRelUsername: R,
      relationship: {
        firstName: f,
        lastName: P,
        relationType: T || "",
        myHealthOneId: N,
        id: x,
        phone: i,
        phoneType: s
      }
    }),
    onError: (p) => {
      console.error("Error updating relationship:", p);
    }
  }), { mutate: W, isPending: se } = De({
    onSuccess: () => {
      d.invalidateQueries({ queryKey: ue.user("FULL") }), k();
    },
    onError: (p) => {
      console.error("Error adding guardian contact:", p);
    }
  }), { mutate: le } = Ge({
    onSuccess: () => W({
      flag: !0,
      connectedRelUsername: R,
      relationship: {
        firstName: f,
        lastName: P,
        relationType: T || "",
        myHealthOneId: N,
        id: x,
        phone: i,
        phoneType: s
      }
    }),
    onError: (p) => {
      console.error("Error updating relationship:", p);
    }
  }), ce = J(
    () => {
      var p;
      return ((p = y == null ? void 0 : y.filter((L) => (L == null ? void 0 : L.relationType) !== "SELF")) == null ? void 0 : p.reduce((L, C) => {
        var q;
        const A = (q = C == null ? void 0 : C.id) == null ? void 0 : q.toString(), F = [C == null ? void 0 : C.firstName, C == null ? void 0 : C.lastName].filter(Boolean).join(" ");
        return A && F && L.push({ value: A, label: F }), L;
      }, [])) || [];
    },
    [y]
  ), de = () => {
    var p;
    if (E)
      if (M)
        h ? le({
          relationship: {
            id: x,
            myHealthOneId: l,
            firstName: u,
            lastName: c,
            relationType: T || "",
            phone: i,
            phoneType: s
          },
          flag: !0,
          connectedRelUsername: R
        }) : ie({
          payload: {
            id: x,
            myHealthOneId: l,
            firstName: u,
            lastName: c,
            relationType: T || "",
            connectedRelUsername: R
          },
          mhoId: (p = e == null ? void 0 : e.user) == null ? void 0 : p.myHealthOneId
        });
      else {
        const C = ((e == null ? void 0 : e.dependentRelationships) || []).find(
          (A) => {
            var F;
            return ((F = A == null ? void 0 : A.id) == null ? void 0 : F.toString()) === V;
          }
        );
        h ? W({
          flag: !0,
          connectedRelUsername: R,
          relationship: {
            ...C,
            relationType: T || ""
          }
        }) : Q({
          flag: !0,
          connectedRelUsername: R,
          relationship: {
            ...C,
            relationType: T || ""
          }
        });
      }
  };
  return typeof window > "u" ? null : /* @__PURE__ */ b(
    U,
    {
      label: o,
      active: n,
      backdropDismiss: !1,
      size: "large",
      onNeuDismiss: a,
      children: [
        /* @__PURE__ */ t(fe, { className: "px-2", errorMessage: g }),
        /* @__PURE__ */ t("div", { className: qe("pt-1", "p-3", { "overflow-visible": M }), children: /* @__PURE__ */ b(
          v,
          {
            onSubmit: de,
            methods: K,
            cancelButtonText: r("Mho.PageContent.Profile.EmergencyContact.Label.Cancel"),
            submitButtonText: r("Mho.PageContent.Profile.EmergencyContact.Label.Save"),
            buttonsAlignment: "end",
            isSubmitDisabled: oe,
            onCancel: k,
            children: [
              /* @__PURE__ */ b(
                me,
                {
                  name: "isUserEmergecyContact",
                  label: ae,
                  value: "yes",
                  onNeuChange: (p) => {
                    Y(p.value === "yes");
                  },
                  required: !0,
                  children: [
                    /* @__PURE__ */ t(me.Item, { label: "Yes", value: "yes" }),
                    /* @__PURE__ */ t(me.Item, { label: "No", value: "no" })
                  ]
                }
              ),
              M ? /* @__PURE__ */ t(
                B,
                {
                  name: pe.relationshipType,
                  label: r(
                    "Mho.Profile.InsuranceEmploymentInformation.InsuranceInfo.NewInsuranceForm.RelationshipFieldLabel"
                  ),
                  nullItemLabel: r(
                    "Mho.PageContent.Profile.EmergencyContact.Label.SelectConnectedRelationship"
                  ),
                  items: D || [],
                  required: !0,
                  addNullItem: !1
                }
              ) : /* @__PURE__ */ b(Ie, { children: [
                /* @__PURE__ */ b(v.Row, { children: [
                  /* @__PURE__ */ t(
                    B,
                    {
                      name: pe.relationshipId,
                      label: r("Mho.PageContent.Profile.EmergencyContact.Labels.ContactName"),
                      items: ce || [],
                      required: !0
                    }
                  ),
                  /* @__PURE__ */ t(
                    B,
                    {
                      name: pe.relationshipType,
                      label: r("Mho.PageContent.Profile.EmergencyContact.Label.RelationshipType"),
                      items: D || [],
                      required: !0
                    }
                  )
                ] }),
                /* @__PURE__ */ t("p", { children: r("Mho.PageContent.Profile.EmergencyContact.Label.AddRelationshipNote") })
              ] }),
              /* @__PURE__ */ t(
                v.Loader,
                {
                  isPending: h ? se : re,
                  kind: "spinner"
                }
              )
            ]
          }
        ) })
      ]
    }
  );
}, ft = ({ rendering: o, fields: n }) => {
  var L, C, A, F, q, Ee, Te, Ne, Re, Le, Oe, Se;
  const { t: a } = $(), g = He(), [u, c] = Z(null), l = ((L = n == null ? void 0 : n.isSupportConsole) == null ? void 0 : L.value) ?? !1, h = Ye(), r = l ? !h : !1, { isConnectedRelationship: d, queryParams: E } = _({
    levelOfDetail: "FULL"
  }), { data: e, refetch: y } = $e({
    queryParams: E,
    enabled: l ? h : !0
  }), { refetch: f } = ee(), { snackbarProps: P, showSnackbar: m } = Xe(), i = e == null ? void 0 : e.user.emergencyContactUserRelationship, s = (C = e == null ? void 0 : e.user) == null ? void 0 : C.guardianUserRelationship, x = ct((e == null ? void 0 : e.user.dob) || "") < 18, N = async () => {
    var O;
    g.invalidateQueries({ queryKey: ue.user("FULL") }), m(
      a("Mho.PageContent.Profile.GeneralInformation.ProfileSuccessfullyChanged"),
      "success",
      5
    ), !l && !d && await _e(((O = e == null ? void 0 : e.user) == null ? void 0 : O.myHealthOneId) || ""), await y(), await f();
  }, {
    isOpen: R,
    openModal: M,
    closeModal: Y
  } = w(), { mutate: te, isPending: K } = ke({
    onSuccess: () => N(),
    onError: (O) => c(O)
  }), { mutate: j, isPending: ne } = We({
    onSuccess: () => N(),
    onError: (O) => c(O)
  }), {
    isOpen: V,
    openModal: T,
    closeModal: oe
  } = w(), { mutate: k, isPending: ae } = De({
    onSuccess: () => N(),
    onError: (O) => c(O)
  }), { mutate: D, isPending: Q } = Ge({
    onSuccess: () => N(),
    onError: (O) => c(O)
  }), {
    isOpen: re,
    openModal: ie,
    closeModal: W
  } = w(), {
    isOpen: se,
    openModal: le,
    closeModal: ce
  } = w(), {
    isOpen: de,
    openModal: G,
    closeModal: z
  } = w(), {
    isOpen: X,
    openModal: H,
    closeModal: p
  } = w();
  return /* @__PURE__ */ t(je, { className: "p-3", children: /* @__PURE__ */ b(
    fe,
    {
      level: "2",
      titleClassName: "neu-display-3 fw-bold",
      componentName: o == null ? void 0 : o.componentName,
      errorMessage: u == null ? void 0 : u.message,
      className: "w-100 d-flex flex-column",
      titleText: n.title.value,
      descriptionRichText: n.description,
      children: [
        /* @__PURE__ */ t("div", { className: "w-100 d-flex flex-column row-gap-4 align-items-start mt-5", children: /* @__PURE__ */ t(
          I,
          {
            headerText1: n.contactInformationTitle.value,
            descriptionContent: /* @__PURE__ */ t(ve, { field: n.contactInformationDescription }),
            children: i ? /* @__PURE__ */ t(
              I.Item,
              {
                itemText1: `${i == null ? void 0 : i.firstName} ${i == null ? void 0 : i.lastName}`,
                itemSubText: ge((i == null ? void 0 : i.relationType) || ""),
                onEditButtonClick: (A = n == null ? void 0 : n.isConnectedRelationship) != null && A.value ? G : M,
                onDeleteButtonClick: ie
              }
            ) : /* @__PURE__ */ t(
              I.AddButton,
              {
                text: n.ctaText.value,
                onClick: (F = n == null ? void 0 : n.isConnectedRelationship) != null && F.value ? G : M
              }
            )
          }
        ) }),
        /* @__PURE__ */ t(
          Ae,
          {
            heading: a("Mho.PageContent.Profile.EmergencyContact.Label.SelectEmergencyContact"),
            buttonTitle: a("Mho.PageContent.Profile.EmergencyContact.Label.AddNewRelationship"),
            onCreate: te,
            onEdit: j,
            preSelectedRelationship: i == null ? void 0 : i.myHealthOneId,
            isOpen: R,
            closeModal: Y
          }
        ),
        /* @__PURE__ */ t(
          Fe,
          {
            heading: a("Mho.PageContent.Profile.EmergencyContact.Label.Remove"),
            description: a("Mho.PageContent.Profile.EmergencyContact.Label.RemoveDescription"),
            deleteContact: j,
            contactId: i == null ? void 0 : i.myHealthOneId,
            isOpen: re,
            closeModal: W
          }
        ),
        d && /* @__PURE__ */ t(
          we,
          {
            heading: a("Mho.PageContent.Profile.EmergencyContact.Label.SelectEmergencyContact"),
            active: de,
            onClose: z,
            modalContentError: null,
            userLastName: ((q = e == null ? void 0 : e.user) == null ? void 0 : q.lastName) || "",
            userFirstName: ((Ee = e == null ? void 0 : e.user) == null ? void 0 : Ee.firstName) || "",
            relatedMhoId: ((Te = e == null ? void 0 : e.user) == null ? void 0 : Te.myHealthOneId) || ""
          }
        ),
        x ? /* @__PURE__ */ b(Ie, { children: [
          /* @__PURE__ */ t("div", { className: "w-100 mb-5 d-flex flex-column row-gap-4 align-items-start", children: /* @__PURE__ */ t(
            I,
            {
              headerText1: n.guardianTitle.value,
              descriptionContent: /* @__PURE__ */ t(ve, { field: n.guardianDescription }),
              children: s ? /* @__PURE__ */ t(
                I.Item,
                {
                  itemText1: `${s == null ? void 0 : s.firstName} ${s == null ? void 0 : s.lastName}`,
                  itemSubText: ge((s == null ? void 0 : s.relationType) || ""),
                  onEditButtonClick: (Ne = n == null ? void 0 : n.isConnectedRelationship) != null && Ne.value ? H : T,
                  onDeleteButtonClick: le
                }
              ) : /* @__PURE__ */ t(
                I.AddButton,
                {
                  text: n.guardianCTAText.value,
                  onClick: (Re = n == null ? void 0 : n.isConnectedRelationship) != null && Re.value ? H : T
                }
              )
            }
          ) }),
          /* @__PURE__ */ t(
            Ae,
            {
              heading: a("Mho.PageContent.Profile.EmergencyContact.Label.SelectRelationship"),
              buttonTitle: a("Mho.PageContent.Profile.EmergencyContact.Label.AddNewRelationship"),
              onCreate: k,
              onEdit: D,
              preSelectedRelationship: s == null ? void 0 : s.myHealthOneId,
              isOpen: V,
              closeModal: oe
            }
          ),
          /* @__PURE__ */ t(
            Fe,
            {
              heading: a("Mho.PageContent.Profile.EmergencyContact.Label.RemoveGuardian"),
              description: a(
                "Mho.PageContent.Profile.EmergencyContact.Label.RemoveGuardianDescription"
              ),
              deleteContact: D,
              contactId: s == null ? void 0 : s.myHealthOneId,
              isOpen: se,
              closeModal: ce,
              isGuardian: !0
            }
          ),
          /* @__PURE__ */ t(
            we,
            {
              heading: a("Mho.PageContent.Profile.EmergencyContact.Label.SelectRelationship"),
              active: X,
              onClose: p,
              modalContentError: null,
              userLastName: ((Le = e == null ? void 0 : e.user) == null ? void 0 : Le.lastName) || "",
              userFirstName: ((Oe = e == null ? void 0 : e.user) == null ? void 0 : Oe.firstName) || "",
              relatedMhoId: ((Se = e == null ? void 0 : e.user) == null ? void 0 : Se.myHealthOneId) || "",
              isGuardian: !0
            }
          )
        ] }) : null,
        /* @__PURE__ */ t(Qe, { ...P }),
        /* @__PURE__ */ t(
          Je,
          {
            isVisible: r || K || ne || ae || Q
          }
        )
      ]
    }
  ) });
}, Qt = nt()(
  ft
);
export {
  Qt as MhoEmergencyContact
};
